import './UploadStatusTable.scss';

import React from 'react';
import PropTypes from 'prop-types';
import { List } from 'immutable';

import DataTable from 'src/component/UI/DataTable';
import LinearProgress from '@mui/material/LinearProgress';
import { useTranslation } from 'src/i18n';

export default function UploadStatusTable (props) {
  const { t } = useTranslation();
  const { uploadData } = props;

  return (
    <div data-testid='upload-status-table' className='upload-status-table'>
      <DataTable
        columns={[
          {
            id: 'file-upload-name',
            Header: t('upload.file'),
            sortable: false,
            accessor: row => row.name
          },
          {
            id: 'file-upload-status',
            Header: t('common.status'),
            sortable: false,
            accessor: (row: any) => row.status === 'pending' ?
              (<LinearProgress className={row.status} />) :
              row.status === 'success' ?
                (<LinearProgress className={row.status} variant='determinate' value={100} />) :
                row.status === 'rejected' ?
                  t('upload.invalidFileType') :
                  row.status === 'failed' ?
                    t('upload.errorUploading') :
                    t('upload.unknownError')
          }
        ]}
        data={List(uploadData)}
      />
    </div>
  );
}

UploadStatusTable.propTypes = {
  uploadData: PropTypes.array
};

UploadStatusTable.defaultProps = {
  uploadData: []
};
